import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminPollSurvey = (args, config) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'search', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/poll/surveys`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiReadAdminPollSurvey = (id, config) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'get', id],
        queryFn: () => ((async (id) => {
            if (!!id) {
                return generalRequest.get(`/admin/poll/survey/${id}`)
            }
        })(id)),
    })
}

export const useApiSearchStudentSurveyCertificate = (certificateId, enable) => {
    return useQuery({
        enabled: enable,
        queryKey: ['student', 'survey', 'certificate', certificateId],
        queryFn: () => ((async (certificateId) => {
            return generalRequest.get(`/student/survey/certificate/${certificateId}?ac=` + localStorage.getItem('ac'))
        })(certificateId)),
    })
}

export const useApiReadStudentSurveyPublic = (survey_id, enable) => {
    return useQuery({
        enabled: enable,
        queryKey: ['student', 'survey', 'public-detail', survey_id],
        queryFn: () => ((async (survey_id) => {
            return generalRequest.get(`/student/survey/${survey_id}`)
        })(survey_id)),
    })
}

export const useApiSearchStudentSurveyPublic = (args) => {
    return useQuery({
        queryKey: ['student', 'survey', 'public'],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/student/survey/`, {params: args})
        })(args)),
    })
}

export function useApiCreateAdminPollSurvey() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/poll/survey`, data)
            })(data))
    });
}

export function useApiUpdateAdminPollSurvey() {
    return useMutation({
        mutationFn: ({id, data}) =>
            ((async (id, data = {}) => {
                return generalRequest.put(`/admin/poll/survey/${id}`, data)
            })(id, data))
    });

}


export function useApiDeleteAdminPollSurvey() {
    return useMutation({
        mutationFn: ({id, data}) =>
            ((async (id) => {
                return generalRequest.delete(`/admin/poll/survey/${id}`)
            })(id, data))
    });
}

export function useApiUpdateAdminPollSurveyRelated() {
    return useMutation({
        mutationFn: ({id, data}) =>
            ((async (id, data = {}) => {
                return generalRequest.put(`/admin/poll/survey/${id}/related`, data)
            })(id, data))
    });
}

export function useApiCreateStudentSurveyCertificateAnswer() {
    return useMutation({
        mutationFn: ({certificateId, data}) =>
            ((async (certificateId, data = {}) => {
                return generalRequest.post(`/student/survey/certificate/${certificateId}?ac=` + localStorage.getItem('ac'), data)
            })(certificateId, data))
    });
}

export function useApiCreateStudentSurveyPublicAnswer() {
    return useMutation({
        mutationFn: ({survey_id, data}) =>
            ((async (survey_id, data = {}) => {
                return generalRequest.post(`/student/survey/${survey_id}`, data)
            })(survey_id, data))
    });
}

export const useApiSearchAdminPollResultQuestion = (args) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'results', args],
        queryFn: ({pageParam = args.page ?? 1}) => (((params) => {
            return generalRequest.get('/admin/poll/result/questions', {params});
        })({...args, page: pageParam})),
    })
}

